<template>
  <div class="animated fadeIn" v-if="relatedLoaded">
      <div class="card">
        <div class="card-body">
          <b-row>
            <b-col xs="6">
              <h3 class="text-info">{{versions && versions.length ? "Outras versões" : templateName + "s relacionados"}}</h3>
            </b-col>
            <!--
            <b-col xs="6" class="text-right">
              <img src="/img/drag.png" style="width: 40px;"/>
            </b-col>-->
          </b-row>
          <div style="overflow-x: scroll;">
            <b-row class="flex-nowrap">
              <b-col xl="2" md="2" sm="3" cols="3" class="mb-4 text-center" v-for="template in templates"
                v-bind:key="template._id">
                <b-row>
                  <b-col sm="12" class="text-center">
                    <div id="image" class="text-center" style="width: 100%; text-align: center;">
                      <a v-if="!template.isStory" target="_blank" @click="selectTemplate(template._id)">
                        <div class="hovereffect" style="cursor: pointer !important;">
                          <img class="img-responsive" v-bind:src="template.thumbnail" alt style="max-height: 100%;" />
                          <div class="overlay">
                            <h2></h2>
                            <p>Visualizar</p>
                          </div>
                        </div>
                      </a>

                      <a v-if="template.isStory" target="_blank" @click="selectTemplate(template._id)">
                        <div class="hovereffect" style="cursor: pointer !important;">
                          <img class="img-responsive" v-bind:src="template.thumbnail" alt style="max-height: 100%;" />
                          <div class="overlayStory">
                            <p>Visualizar</p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <div class="text-center" v-if="versions && ((versions.length > 6 && !isMobile) || (versions.length > 4 && isMobile))">
            <img src="/img/drag.png" style="max-width: 150px;"/>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import service from "./../service";
import config from "../config";
import { isMobile } from "mobile-device-detect";
import DesignBox from "./theme/DesignBox";

export default {
  name: "RelatedPosts",
  props: ['value'],
  data() {
    return {
      config: config,
      me: undefined,
      isMobile: isMobile,
      relatedLoaded: false,
      related: [],
      versions: [],
      selectedTemplate: this.value
    };
  },
  watch: {
    template () { 
      this.loadRelated();
    },
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    isAdmin: function() {
      return localStorage.admin;
    },
    templates: function() {
      if(this.versions && this.versions.length) {
        return this.versions;
      } else {
        return this.related;
      }
    }
  },
  methods: {
    loadRelated: function() {
      if (this.selectedTemplate) {
        service.getRelatedPosts(this.selectedTemplate).then(
          response => {
            this.relatedLoaded = true;
            this.versions = response.versions;
            this.related = response.related;
            this.me = response;
          },
          () => {
            this.showError = true;
          }
        );
      }
    },
    selectTemplate: function(templateId) {
      this.$emit('input', templateId); //old way, should be deprecated
      this.$emit('templateSelected', templateId);
    }
  },
  mounted: function() {
    this.loadRelated();
  },
  components: { DesignBox }
};
</script>


<style scoped>
.hovereffect {
  width: wrap;
  height: wrap;
  float: left;
  overflow: hidden;
  position: relative;
  text-align: center;
  cursor: default;
}

.hovereffect .overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  padding: 50px 20px;
}

.hovereffect:hover img {
  opacity: 0.4;
  filter: alpha(opacity=40);
}

.hovereffect .overlayStory {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  padding: 50px 2px;
}



.hovereffect h2 {
  text-transform: uppercase;
  color: #fff;
  text-align: center;
  position: relative;
  font-size: 17px;
  overflow: hidden;
  font-weight: bold;
  padding: 0.5em 0;
  background-color: transparent;
}

.hovereffect h2:after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #fff;
  font-weight: bold;
  content: "";
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}

.hovereffect:hover h2:after {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

/* Below breaks scrollbar */

.hovereffect img {
  display: block;
  position: relative;
  max-width: none;
  width: calc(100%);
  backface-visibility: hidden;
}

.hovereffect a,
.hovereffect p {
  font-weight: bold;
  font-size: 100%;
  color: #fff;
  opacity: 0;
  filter: alpha(opacity=0);
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.hovereffect:hover a,
.hovereffect:hover p {
  opacity: 1;
  filter: alpha(opacity=100);
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

</style>